import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

interface AnimationContextType {
  animationsEnabled: boolean;
  setAnimationsEnabled: (enabled: boolean) => void;
}

const AnimationContext = createContext<AnimationContextType | undefined>(undefined);

export const AnimationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [animationsEnabled, setAnimationsEnabledState] = useState<boolean>(true);

  // Load preference from localStorage on initial load
  useEffect(() => {
    const storedPreference = localStorage.getItem("animationsEnabled");
    if (storedPreference !== null) {
      setAnimationsEnabledState(JSON.parse(storedPreference));
    }
  }, []);

  const setAnimationsEnabled = (enabled: boolean) => {
    setAnimationsEnabledState(enabled);
    localStorage.setItem("animationsEnabled", JSON.stringify(enabled));
  };

  return (
    <AnimationContext.Provider value={{ animationsEnabled, setAnimationsEnabled }}>
      {children}
    </AnimationContext.Provider>
  );
};

export const useAnimationSettings = (): AnimationContextType => {
  const context = useContext(AnimationContext);
  if (context === undefined) {
    throw new Error('useAnimationSettings must be used within an AnimationProvider');
  }
  return context;
}; 